import { Component, OnInit, ViewChild } from '@angular/core';
import {  ConfirmationService, MessageService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';

import { GlobalService } from 'src/app/_services/global.service';

import { Router } from '@angular/router';
import { GridService } from 'src/app/_services/grid.service';

import { ApiService } from 'src/app/_services/api.service';
import { CheckboxRenderer } from  'src/app/components/grid-addons/checkbox-renderer/checkbox-renderer.component';

import {
  ColDef,
  CellEditingStartedEvent,
  GridReadyEvent,
} from 'ag-grid-community';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import 'ag-grid-enterprise';
import * as moment from 'moment';

@Component({
  selector: 'app-survey-models',
  templateUrl: './survey-models.component.html',
  styleUrls: ['./survey-models.component.css'],
  providers: [ MessageService,ConfirmationService]
})

export class SurveyModelsComponent implements OnInit {
  
  filtroCountryList:any=[];

  filtrocountry='';
  showArchived:boolean=false;
  
  columns: ColDef[] = [
    { field: 'id',  
      headerName: '', 
      maxWidth:50,
      cellRenderer: params =>    {   
          if(typeof params.value == 'undefined')
            return '';
            return '<a title="'+'Update survey model'+'"><i class="pointer pi pi-pencil"></i></a>'; 
      },
      onCellClicked:function(data){ 
          _this.router.navigate(['/dashboard/surveys/survey-models-edit/update',data.data.id]);
      }   
    },
    { field: 'id',  
      headerName: '', 
      maxWidth:50,
      cellRenderer: params =>    {   
          if(typeof params.value == 'undefined')
            return '';
            return '<a title="'+'Settings'+'"><i class="pointer pi pi-cog"></i></a>'; 
      },
      onCellClicked:function(data){ 
          _this.router.navigate(['/dashboard/surveys/survey-settings',data.data.id]);
      }   
    },
 
    
      { field: 'name',headerName: 'Name',minWidth:400 },
      
      { field: 'date_creation',headerName: 'Creation date', minWidth:220,
      valueFormatter: (data) => moment(data.value).format('DD/MM/YYYY HH:mm') },
      { field: 'date_lastmodify',headerName: 'Last modify', minWidth:220,
      valueFormatter: (data) => moment(data.value).format('DD/MM/YYYY HH:mm') },
      
    { field: 'lang',headerName: 'Language' },
    { field: 'used_in',minWidth:200,headerName: 'Survey' },
    { field: 'mandatory',minWidth:200,headerName: 'Mandatory schema' },
    { field: 'questions_count',headerName: 'Questions' },
    { field: 'id',  
      headerName: '', 
      maxWidth:50,
      cellRenderer: params =>    {   
          if(typeof params.value == 'undefined')
            return '';
          if(params.data.used_in)
            return '';
     
          return '<a title="'+'Delete survey model'+'"><i class="pointer pi pi-trash"></i></a>'; 
      },
      onCellClicked:function(params){ 
          if(params.data.used_in)
            return;
            _this.confirmationService.confirm({
              message: 'Attention: do you confirm the delete of the model?',
              accept: () => {
                _this.apiService.deleteSSurveyModel({id:params.data.id}).subscribe(data => {
                  _this.addSingle('success', 'Success', 'Survey model deleted');
                  _this.load();
                });
              }
            });
       },
      }
    ];

  frameworkComponents = {
    checkboxRenderer: CheckboxRenderer
  }
  surveysmodelslist: any[] = [];
  surveysmodelslistAll: any[] = [];
  gridApi;
  defaultColDef = {
    width: 250,
    minWidth: 100,
    sortable:true,
    flex:1
  };

 
  
  defaultSortModel = [
    { colId: 'name', sort: 'asc', sortIndex: 0 },
  ];

 
  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
    params.api.showLoadingOverlay();
    params.columnApi.applyColumnState({ state: this.defaultSortModel });
  }

  constructor(
    private router: Router,
    private messageService: MessageService,
    private translate: TranslateService,
    public globalService: GlobalService,
    public gridService: GridService,
    private apiService: ApiService,
    private confirmationService: ConfirmationService,
  ) { }

  
  ngOnInit(): void {
    _this=this;
    this.load();
   
  }

  load(){
    this.filtroCountryList=[];
    this.filtroCountryList.push({label:'All',value:''});
    const params: any = {'archived' : this.showArchived};
    this.apiService.get('surveys-models/listall',params).subscribe(data => {
      this.surveysmodelslist=data.Result;
      this.surveysmodelslistAll=data.Result;
      this.surveysmodelslist.forEach((r)=>{
        if(r.company){
          if(this.filtroCountryList.filter(a=>a.value==r.company).length==0){
            this.filtroCountryList.push({label:r.company,value:r.company});
          }
        }
        
      });
      this.gridApi.redrawRows();
      });
    
  }
  
  changeArchived(){
    this.load();

  }
  change(event){
    
    this.surveysmodelslist=this.surveysmodelslistAll;
    if((this.filtrocountry)&&(this.filtrocountry!='')){
      this.surveysmodelslist=this.surveysmodelslist.filter(a=>a.company==this.filtrocountry);
      this.gridApi.redrawRows();
    } 
  }

  addSingle(sev: string, sum: string, det: string) {
    this.messageService.add({severity: sev, summary: sum, detail: det});
  }

}
var _this;